var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFelizVitaLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "235.457 453.608 191.639 161.799",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 0,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(-32.07291,-32.70179,-32.70179,32.07291,309.4086,490.61313)",
    spreadMethod: "pad",
    id: "linearGradient26"
  }, /*#__PURE__*/React.createElement("stop", {
    style: {
      stopOpacity: 1,
      stopColor: "#0086c9"
    },
    offset: 0,
    id: "stop22"
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopOpacity: 1,
      stopColor: "#12255c"
    },
    offset: 1,
    id: "stop24"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 0,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(-101.82239,104.21822,104.21822,101.82239,302.78854,389.81079)",
    spreadMethod: "pad",
    id: "linearGradient68"
  }, /*#__PURE__*/React.createElement("stop", {
    style: {
      stopOpacity: 1,
      stopColor: "#009fe3"
    },
    offset: 0,
    id: "stop58"
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopOpacity: 1,
      stopColor: "#37aae1"
    },
    offset: 0.1215,
    id: "stop60"
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopOpacity: 1,
      stopColor: "#37aae1"
    },
    offset: 0.2564,
    id: "stop62"
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopOpacity: 1,
      stopColor: "#1d70b8"
    },
    offset: 0.6029,
    id: "stop64"
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopOpacity: 1,
      stopColor: "#113171"
    },
    offset: 1,
    id: "stop66"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "g8",
    transform: "matrix(1.333333, 0, 0, -1.333333, 0, 1122.520036)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g10"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g12"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g18"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g20"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 256.072,489.901 -8.098,-8.099 53.226,-53.226 8.098,8.099 c 14.698,14.697 14.698,38.529 0,53.226 v 0 c -7.348,7.348 -16.982,11.023 -26.613,11.023 v 0 c -9.633,0.001 -19.263,-3.674 -26.613,-11.023",
    style: {
      fill: "url(#linearGradient26)",
      stroke: "none"
    },
    id: "path28"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "g46"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g48"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g54"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g56"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 188.328,491.561 c -15.407,-14.632 -15.643,-38.988 -0.712,-53.919 v 0 l 8.099,-8.098 46.368,-46.368 c 3.787,-3.788 9.929,-3.788 13.716,0 v 0 c 0,0 34.219,35.361 46.368,46.368 v 0 c 11.644,10.549 14.032,16.595 14.032,16.595 v 0 c -4.061,-4.154 -8.659,-8.673 -14.039,-9.11 v 0 c -4.043,-0.327 -6.476,-0.185 -10.782,3.382 v 0 c -0.341,0.283 -0.671,0.593 -0.985,0.907 v 0 l -41.452,41.452 -7.498,7.498 c -7.543,7.543 -17.556,11.416 -27.527,11.416 v 0 c -9.232,0 -18.426,-3.32 -25.588,-10.123",
    style: {
      fill: "url(#linearGradient68)",
      stroke: "none"
    },
    id: "path70"
  })))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFelizVitaLogo);
export default __webpack_public_path__ + "static/media/feliz_vita_logo.0a4822ad28815db64507a9cf52233750.svg";
export { ForwardRef as ReactComponent };